import { useEffect } from 'react'

import { api } from 'app/api'
import { GET_ACQUIRING_SETTINGS, convertParams, convertResult } from 'app/common/api/requests/payments/acquiring2/settings/get'

import { acquiringSettings, acquiringSettingsParams } from '../dataBox'


export function useAcquiringSettingsFetch() {
  useEffect(() => {
    if (!acquiringSettings.init) return () => { }
    acquiringSettings.addDataReceiver(async () => {
      const res = await api.request(GET_ACQUIRING_SETTINGS, {
        error: 'Не удалось получить информацию по эквайрингу',
        convertions: {
          convertParams,
          convertResult,
        },
      })
      return res
    })

    const unsubsribe = acquiringSettingsParams.subscribeDataBox(acquiringSettings)
    acquiringSettingsParams.updateData(() => ({}))

    return () => {
      unsubsribe()
      acquiringSettings.resetToDefault()
      acquiringSettingsParams.resetToDefault()
    }
  }, [])
}
